/**
 * api接口的统一出口
 */
// login模块接口
import login from '@/network/login';
import home from '@/network/home';
import admin from '@/network/admin';
import goodsmsg from '@/network/goodsmsg';
import medicine from '@/network/medicine';
import information from '@/network/information';
import business from '@/network/business';
import common from '@/network/common';
import brand from '@/network/brand';
import manufacture from '@/network/manufacture';
import menu from '@/network/menu';
import financial from '@/network/financial';
import entergoods from '@/network/entergoods';
import setting from '@/network/setting';
import user from '@/network/user';
import upload from '@/network/upload';
import label from '@/network/label';
import postReview from '@/network/postReview';
import salesPerson from "@/network/salesPerson";
import orderList from '@/network/orderList';
// 其他模块的接口……

// 导出接口
export default {
  login,
  label,
  postReview,
  salesPerson,
  home,
  admin,
  goodsmsg,
  medicine,
  information,
  business,
  common,
  brand,
  manufacture,
  menu,
  financial,
  entergoods,
  setting,
  user,
  upload,
  orderList,
  // ……
}



// WEBPACK FOOTER //
// ./src/api/index.js